import { useEffect, useState } from "react";
import { useAuthedApi } from "../../lib/api";
import AdminPanel from "../dashboard/AdminPanel";

export default function Overview({ onGo }) {
  const api = useAuthedApi();
  const [o, setO] = useState(null);
  const load = () => { api("get", "/admin/overview").then(setO); };
  useEffect(load, []); // eslint-disable-line react-hooks/exhaustive-deps

  const cards = o ? [
    ["Total listings", o.listings, "listings"], ["Live listings", o.active, "listings"], ["Dealer stores", o.dealers, "dealers"],
    ["Pending verifications", o.pending_verifications, "dealers"], ["Users", o.users, "users"], ["Enquiries & offers", o.leads, "leads"],
  ] : [];
  return (
    <div className="space-y-8" data-testid="admin-overview">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {cards.map(([l, v, t]) => (
          <button key={l} onClick={() => onGo(t)} className="lux-card p-5 text-left hover:border-[#D4AF37]/60 transition-colors" data-testid={`overview-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <p className={`font-display text-4xl ${l === "Pending verifications" && v > 0 ? "text-amber-400" : "gold-text"}`}>{v}</p>
            <p className="text-[10px] uppercase tracking-widest text-gray-500 mt-1">{l}</p>
          </button>
        ))}
      </div>
      <AdminPanel onChange={load} />
    </div>
  );
}
